interface ProjectTileProps {
    phaseColor?: any | null;
    data?: any | null;
    earliestStartDate?: any | null;
    daysDifference?: any | null;
    rowWidth?: any | null;
    open?: any | null
    top?: any | null
}

const ProjectTile:React.FC<ProjectTileProps>  =({ phaseColor, data, earliestStartDate, daysDifference, rowWidth, top: _top, open: _open })=> {

  const start = new Date(data.date_start);
  const end = new Date(data.date_end);

  // Calculate the left margin in pixels based on rowWidth
  const daysFromStart = (start.getTime() - new Date(earliestStartDate).getTime()) / (1000 * 60 * 60 * 24);
  const pixelsLeft = (daysFromStart / daysDifference) * parseFloat(rowWidth);

  // Calculate the width in pixels based on rowWidth
  const durationInDays = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
  const pixelsWidth = (durationInDays / daysDifference) * parseFloat(rowWidth);

  // Set styles using pixel values
  const style = {
    marginLeft: `${Math.min(pixelsLeft, parseFloat(rowWidth))}px`,
    width: `${Math.min(pixelsWidth, parseFloat(rowWidth))}px`,
  };

  return (
    <div
      className={`text-white text-[12px] leading-[12px] px-[15px] py-0 rounded-[25px] mt-[0] mx-[0] mb-[4px] h-[30px] absolute flex -top-[33px] items-center opacity-100 -z-[1] ${phaseColor(data.project_phase.toLowerCase().replace(/ /g, '-').replace(/\&/g, ''))}`}
      style={style}
    >
      {data.project_phase}
    </div>
  );
};

export default ProjectTile;
